import { cn } from "../../lib/utils"

export function Separator({ className, orientation = "horizontal", ...props }) {
  return (
    <div
      className={cn(
        "shrink-0 bg-border bg-gray-200",
        orientation === "horizontal" ? "h-[1px] w-full" : "w-[1px]",
        className,
      )}
      {...props}
    />
  )
}
